// Questionarios do onboarding (copia EXATA das telas do Figma).
// Escala Likert 1-5. RN-003. Codigos [Sugerido] para identificar cada afirmacao.

export const LIKERT_LEGEND =
  "1 – Discordo totalmente | 2 – Discordo | 3 – Neutro | 4 – Concordo | 5 – Concordo totalmente";

export const PERSONALITY_GROUPS = [
  { trait: "openness", title: "Abertura à Experiência", statements: [
    "Tenho uma imaginação vívida.",
    "Gosto de refletir sobre ideias abstratas.",
    "Tenho interesse por arte e cultura.",
    "Gosto de experimentar coisas novas.",
    "Sou curioso(a) intelectualmente.",
  ]},
  { trait: "conscientiousness", title: "Conscienciosidade", statements: [
    "Sou uma pessoa organizada.",
    "Cumpro tarefas com antecedência.",
    "Sou confiável e responsável.",
    "Gosto de manter tudo em ordem.",
    "Evito procrastinar.",
  ]},
  { trait: "extraversion", title: "Extroversão", statements: [
    "Gosto de estar rodeado(a) de pessoas.",
    "Me sinto confortável em ambientes sociais.",
    "Sou uma pessoa comunicativa.",
    "Tenho facilidade em fazer amizades.",
    "Gosto de ser o centro das atenções.",
  ]},
  { trait: "agreeableness", title: "Amabilidade", statements: [
    "Sou compreensivo(a) com os outros.",
    "Evito conflitos sempre que possível.",
    "Tenho empatia pelas pessoas.",
    "Ajudo os outros sempre que posso.",
    "Costumo ser gentil mesmo em situações difíceis.",
  ]},
  { trait: "neuroticism", title: "Neuroticismo", statements: [
    "Fico ansioso(a) com facilidade.",
    "Tendo a me preocupar muito.",
    "Fico irritado(a) com facilidade.",
    "Tenho mudanças de humor frequentes.",
    "Costumo me sentir inseguro(a).",
  ]},
];

export const HABITS_STATEMENTS = [
  "Gosto de manter a casa sempre limpa e organizada.",
  "Tenho horários fixos para dormir e acordar.",
  "Não me incomodo com barulho durante o dia.",
  "Prefiro resolver conflitos com diálogo direto.",
  "Costumo receber visitas com frequência.",
  "Não me importo em compartilhar alimentos ou objetos pessoais.",
  "Prefiro que cada um cuide da sua própria comida e louça.",
  "Gosto de socializar com meus colegas de casa.",
  "Preciso de momentos de silêncio e privacidade todos os dias.",
  "Prefiro dividir igualmente todas as despesas da casa.",
];
